import React from 'react';
import { Dialog, DialogContent } from '@material-ui/core';
import AppBarModal from '../../../../general/AppBarModal';
import TareasTerminadas from '../../../../general/TareasTerminadas';
import emma_w from './../../../../../global/imagenes/emma_w.png';
import DialogAccionesCerrarBienestar from './DialogAccionesCerrarBienestar';
import { BIENESTAR_MODAL_PAPER_FLEX } from '../../helpers/bienestarDetalleConstants';
import MensajeSinPermiso from './MensajeSinPermiso';
import { MENSAJE_SIN_PERMISO_PROFESIONAL } from '../../helpers/bienestarAccesoPermisos';

const PAPER_PROPS = { style: BIENESTAR_MODAL_PAPER_FLEX };
const CONTENT_STYLE = { flex: '1 1 auto', minHeight: 0, overflowY: 'auto', padding: 0 };

function DialogMaterialApoyo({ open, cargando, onClose, puedeVerContenido = true }) {
    return (
        <Dialog
            open={open}
            maxWidth="sm"
            fullWidth
            scroll="paper"
            onClose={onClose}
            PaperProps={PAPER_PROPS}
        >
            <AppBarModal titulo='Material de Apoyo' mostrarModal={onClose} titulo_accion='' />
            <DialogContent style={CONTENT_STYLE}>
                {cargando ? (
                    <TareasTerminadas
                        mensaje='Cargando..'
                        marginTop='7%'
                        imagen={emma_w}
                        widthImg="7%"
                        cargando={true}
                    />
                ) : (
                    puedeVerContenido
                        ? null
                        : <MensajeSinPermiso mensaje={MENSAJE_SIN_PERMISO_PROFESIONAL} />
                )}
            </DialogContent>
            <DialogAccionesCerrarBienestar onClick={onClose} />
        </Dialog>
    );
}

export default React.memo(DialogMaterialApoyo);
